import { render, staticRenderFns } from "./AgentSettings.vue?vue&type=template&id=3f666deb&"
import script from "./AgentSettings.vue?vue&type=script&lang=js&"
export * from "./AgentSettings.vue?vue&type=script&lang=js&"
import style0 from "./AgentSettings.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AgentSettings.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VDivider,
  VFlex,
  VTab,
  VTabs,
})
